var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackCheckboxIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.332031 7.00016C0.332031 3.31826 3.3168 0.333496 6.9987 0.333496C10.6806 0.333496 13.6654 3.31826 13.6654 7.00016C13.6654 10.682 10.6806 13.6668 6.9987 13.6668C3.3168 13.6668 0.332031 10.682 0.332031 7.00016ZM9.7157 4.28829C10.0168 4.50018 10.0891 4.91605 9.87723 5.21716L6.71056 9.71716C6.5941 9.88263 6.40883 9.9863 6.2069 9.9989C6.0049 10.0115 5.80816 9.9317 5.6721 9.78196L4.0054 7.94863C3.75773 7.67616 3.77781 7.25456 4.05025 7.0069C4.32268 6.75923 4.74432 6.7793 4.99199 7.0517L6.09896 8.26943L8.78683 4.44984C8.9987 4.14872 9.41456 4.0764 9.7157 4.28829Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackCheckboxIcon);
export default __webpack_public_path__ + "static/media/blackCheckboxIcon.f9cdbb6ca849bc09ea5bd38844aa9254.svg";
export { ForwardRef as ReactComponent };